module.exports = __webpack_public_path__ + "StagSans-BookItalic-Cy-Gr-Web.woff";